import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./component/header";
import Sidebar from "./component/sidebar";
import Bodycontent from "./component/bodycontent";
import Profile from "./component/profile";
import Layout from "./component/layout";
import { Provider } from "react-redux";
import store from "./store";
import { HelmetProvider } from "react-helmet-async";
import { Helmet } from "react-helmet";

function App() {
  const helmetContext = {};
  return (
    <Provider store={store}>
      <HelmetProvider>
        <Router>
          <Header />
          <Routes>
            <Route path="/:videoId" element={<Layout />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </Router>
      </HelmetProvider>
    </Provider>
  );
}

export default App;
